module.exports = __webpack_public_path__ + "img/link3.93b35495.png";